/* GFI Nexus — shared "was this sent?" status icon
   ─────────────────────────────────────────────────────────────────
   fix-dashboard.md Fase 3 — extracted so BillRegistry.js ("Report
   Sent") and PaymentRegistry.js ("Confirmation Sent") share one
   component instead of duplicating the icon markup. SweetLeafPortal.js's
   own "Passing Sent" column (✓ green / gray clock outline) was checked
   first as a candidate to extract, but it's a much simpler inline
   ternary with only a "sent on {date}" tooltip — no destinatarios/
   from/subject — so it wasn't reused verbatim; this component follows
   the SAME visual language (same ✓ glyph, same clock SVG) but adds the
   richer multi-line tooltip Fase 3 needs. Native `title` attributes are
   plain-text only, so the tooltip is a newline-joined string, not HTML.

   Props:
     - sent    bool     true → green check, false → gray clock outline
     - details { sentAt, sentTo: string[], sentFrom, subject } —
               only read when sent is true
     - lang    "es" | "en" */

function fmtSentAt(iso, lang) {
  if (!iso) return "—";
  try {
    var d = new Date(iso);
    if (isNaN(d.getTime())) return iso;
    return d.toLocaleString(lang === "es" ? "es-MX" : "en-US", { year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit" });
  } catch (e) { return iso; }
}

export default function SentStatusIcon({ sent, details, lang }) {
  if (!sent) {
    return (
      <span title={lang === "es" ? "Aún no enviado" : "Not sent yet"} style={{ display: "inline-flex" }}>
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="var(--color-text-muted)" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="8" cy="8" r="6.5" />
          <path d="M8 4.5V8l2.5 1.5" />
        </svg>
      </span>
    );
  }
  var lines = [];
  lines.push((lang === "es" ? "Enviado: " : "Sent: ") + fmtSentAt(details && details.sentAt, lang));
  if (details && Array.isArray(details.sentTo) && details.sentTo.length > 0) {
    lines.push((lang === "es" ? "Para: " : "To: ") + details.sentTo.join(", "));
  }
  if (details && details.sentFrom) lines.push((lang === "es" ? "De: " : "From: ") + details.sentFrom);
  if (details && details.subject) lines.push((lang === "es" ? "Asunto: " : "Subject: ") + details.subject);
  return (
    <span title={lines.join("\n")} style={{ display: "inline-flex" }}>
      <span style={{ fontSize: 18, fontWeight: 700, color: "#16a34a", lineHeight: 1 }}>{"✓"}</span>
    </span>
  );
}
